/**
 * Same heuristic as smartbanner.js Detector: maxTouchPoints distinguishes
 * real iPads (maxTouchPoints > 0) from Mac desktop Safari (maxTouchPoints = 0).
 */
export function isIosOrIpad(): boolean {
    const { userAgent, maxTouchPoints } = window.navigator;
    return (
        /iPhone|iPad|iPod/i.test(userAgent) ||
        (!('MSStream' in window) && !/X11|Linux|Windows/i.test(userAgent) && maxTouchPoints > 0)
    );
}
